angular.module('templates').constant('Templates', {
    modal: {
        base: '/views/modals/base.html',
        marketingCard: '/views/modals/marketing-card.html',
        sessionExpired: '/views/modals/session-expired.html',
        outdatedBrowser: '/views/modals/outdated-browser.html',
        register: '/views/modals/register.html',
        forgotPassword: '/views/modals/forgot-password.html',
        removeDevice: '/views/modals/remove-device.html',
        deploy: '/views/modals/deploy.html',
        subscriptionConfirmation: '/views/modals/subscription-confirmation.html',
        antitheftPlaySound: '/scripts/controllers/modals/antitheft/antitheft-play-sound.html',
        antitheftDeviceReport: '/views/modals/antitheft-devicereport.html',
        antitheftWipeData: '/views/modals/antitheft-wipedata.html',
        antitheftDeviceLock: '/scripts/controllers/modals/antitheft/antitheft-device-lock.html',
        antitheftDeviceUnlock: '/scripts/controllers/modals/antitheft/antitheft-device-unlock.html',
        antitheftCallDevice: '/views/modals/antitheft-calldevice.html',
        applockLock: '/views/modals/applockplus-lock.html',
        lockDevice: '/scripts/controllers/modals/device/lock-device/lock-device.html',
        unlockDevice: '/scripts/controllers/modals/device/unlock-device/unlock-device.html',
        activationConfirmation: '/views/modals/activation-confirmation.html',
        myAccount: {
            cropImage: '/scripts/controllers/modals/my-account/crop-image/crop-image.html',
        },
        changeLang: '/scripts/controllers/modals/change-lang/change-lang.html',
        languageSwitcher: '/scripts/directives/dashboard/header/language-switcher/language-switcher.html',
    },
    dashboard: {
        base: '/scripts/controllers/dashboard/dashboard.html',
        navigation: '/scripts/controllers/dashboard/navigation/navigation.html',
        products: '/scripts/controllers/dashboard/body/content/products/products.html',
        subscriptions: '/scripts/controllers/dashboard/body/content/subscriptions/subscriptions.html',
        body: '/scripts/controllers/dashboard/body/body.html',
        product: '/scripts/controllers/dashboard/body/content/service-details/service-details.html',
        store: '/scripts/controllers/dashboard/body/content/store/store.html',
        devices: '/scripts/controllers/dashboard/body/content/devices/devices.html',
        deviceDetails: '/scripts/controllers/dashboard/body/content/device-details/device-details.html',
        myAccount: '/scripts/controllers/dashboard/body/content/my-account/my-account.html',
        modals: {
            criticalError: '/scripts/controllers/modals/critical-error/critical-error.html',
        },
    },
    overview: {
        antitheft: '/views/overview/antitheft.html',
    },
    events: '/scripts/directives/dashboard/events/events.html',
    auth: {
        login: '/scripts/controllers/auth/login/login.html',
        setPassword: '/scripts/controllers/auth/set-password/set-password.html',
        landingSetPassword: '/scripts/controllers/auth/set-password/landing-set-password.html',
        tfa: '/scripts/controllers/auth/tfa/tfa.html',
        reset: '/scripts/controllers/auth/reset/reset.html',
        register: '/scripts/controllers/auth/register/register.html',
        forgot: '/scripts/controllers/auth/forgot/forgot.html',
        landingPage: './controllers/auth/landing-page.html',
        confirm: '/scripts/controllers/auth/confirm/confirm.html',
    },
    alert: '/views/alert.html',
    countrySelector: '/views/country-selector.html',

    directives: {
        controls: {
            fancyCheckbox: '/views/directives/controls/fancy-checkbox.html',
        },
        header: '/scripts/directives/dashboard/header/header.html',
        userSettings: '/scripts/directives/dashboard/header/user-settings/user-settings.html',
        accountChooser: '/scripts/directives/dashboard/header/account-chooser/account-chooser.html',
        userEvents: '/scripts/directives/dashboard/header/user-events/user-events.html',
        userInfo: '/scripts/directives/dashboard/header/user-info/user-info.html',
        deviceCard: '/scripts/directives/dashboard/device-card/device-card.html',
        breadcrumb: '/scripts/directives/dashboard/breadcrumb/breadcrumb.html',
        deploymentWizardGenerator:
        '/scripts/directives/dashboard/deployment/wizard-generator/deployment-wizard-generator.html',
        pcDeploymentWizard:
        '/scripts/directives/dashboard/deployment/pc-deployment-wizard/pc-deployment-wizard.html',
        pcEmailDeploymentSuccess:
        '/scripts/directives/dashboard/deployment/pc-email-deployment-success/pc-email-deployment-success.html',
        pcDownloadDeploymentSuccess:
        '/scripts/directives/dashboard/deployment/pc-download-deployment-success/pc-download-deployment-success.html',
        phoneSmsDeploymentSuccess:
        '/scripts/directives/dashboard/deployment/phone-sms-deployment-success/phone-sms-deployment-success.html',
        onlineDeploymentSuccess:
        '/scripts/directives/dashboard/deployment/online-deployment/online-deployment.html',
        phoneDeploymentWizard:
        '/scripts/directives/dashboard/deployment/phone-deployment-wizard/phone-deployment-wizard.html',
        phoneEmailDeploymentSuccess:
        '/scripts/directives/dashboard/deployment/phone-email-deployment-success/phone-email-deployment-success.html',
        chooseDeviceDeploymentWizard:
        '/scripts/directives/dashboard/deployment/choose-device-deployment-wizard/choose-device-deployment-wizard.html',
        chooseOsTypeDeploymentWizard:
        '/scripts/directives/dashboard/deployment/choose-os-type-deployment-wizard' +
        '/choose-os-type-deployment-wizard.html',
        chooseOsTypeWizard: '/scripts/directives/dashboard/deployment/choose-os-type-wizard.html',
        offlineDeploymentSuccess:
        '/scripts/directives/dashboard/deployment/offline-deployment/offline-deployment.html',
        paidDeploymentWizard:
        '/scripts/directives/dashboard/deployment/paid-deployment-wizard/paid-deployment-wizard.html',
        passwordStrength: '/scripts/directives/dashboard/auth/password-strength/password-strength.html',
        changeLanguage: '/scripts/controllers/auth/change-language/change-language.html',
        myAccount: {
            profile: {
                profileDetails: '/scripts/directives/dashboard/my-account/profile/' +
                'profile-details/profile-details.html',
                profileImage: '/scripts/directives/dashboard/my-account/profile/' +
                'profile-image/profile-image.html',
            },
            security: {
                securityPassword: '/scripts/directives/dashboard/my-account/security/' +
                'security-password/security-password.html',
                twoFactorAuth: '/scripts/directives/dashboard/my-account/security/' +
                'two-factor-auth/two-factor-auth.html',
            },
            notifications: '/scripts/directives/dashboard/my-account/notifications/' +
                'notifications.html',
            dataSettings: {
                userData: '/scripts/directives/dashboard/my-account/data-settings/' +
                'user-data/user-data.html',
                disableAccount: '/scripts/directives/dashboard/my-account/data-settings/' +
                'disable-account/disable-account.html',
                deleteAccount: '/scripts/directives/dashboard/my-account/data-settings/' +
                'delete-account/delete-account.html',
            },
        },
        deviceSettings: '/scripts/directives/dashboard/device-settings/device-settings.html',
    },
    device: {
        settings: '/scripts/directives/device/device-settings.html',
    },
    landingPages: {
        downloadKit: '/views/landingPages/download-kit.html',
        underMaintenance: '/views/landingPages/under-maintenance.html',
        notAllowed: '/scripts/controllers/landing-pages/not-allowed/not-allowed.html',
    },
    debug: '/views/directives/custom-debug.html',
});



// WEBPACK FOOTER //
// ./scripts/modules/templates.js